export default function Section({ children, className = "mb-3s", style = {} }) {
  return (
    <section className={`p-3 ${className}`} style={style}>
      {children}
    </section>
  );
}
